<template>
  <div class="h-8 flex gap-4 children:skeleton vans:!gap-2">
    <div class="h-4 w-5 md:w-10 vans:<md:w-10" />
    <div class="h-4 w-16" />
    <div class="h-4 w-16 timberland:hidden vans:hidden" />
    <div class="h-4 w-12 <md:hidden timberland:hidden vans:hidden" />
  </div>
</template>
